import FilePdf from "vue-material-design-icons/FilePdf.vue";
import MoneySign from "../Money.vue";

export default {
  components: {
    "file-pdf-icon": FilePdf,
    "money-sign": MoneySign
  },
  data() {
    return {
      cobranzaUnidades: null,
      pages: 1,
      currentPage: 1,
      items: [],
      fields: [
        { key: "unidad" },
        { key: "debeTotal", label: "Total a deber" },
        {
          key: "cantidadRecibos",
          label: "Cantidad de recibos"
        }
      ],
      entradas: [10, 20, 30],
      entrada: null,
      selected: false,
      isBusy: false,
      isEmpty: false,
      isDisabled: false,
      rows: 1
    };
  },
  // Antes de que se cree el componente, se ejecuta el método de obtener cobranza unidades
  mounted() {
    this.getCobranzaUnidades();
    this.entrada = this.entradas[0].toString();
  },
  computed: {
    perPage: {
      get: function() {
        if (this.selected) {
          return this.entrada;
        } else {
          return (this.entrada = "10");
        }
      },
      set: function() {
        if (this.selected) {
          return this.entrada;
        } else {
          return (this.entrada = "10");
        }
      }
    }
  },
  watch: {
    currentPage: {
      handler: function() {
        this.items = [];
        this.getCobranzaUnidades();
      }
    },
    selected: {
      handler: function() {
        this.perPage = this.entrada;
        this.items = [];
        this.getCobranzaUnidades();
      }
    }
  },
  methods: {
    async getCobranzaUnidades() {
      // Mostrar mensaje de cargando en la página si es que no se muestran los datos aún en la tabla
      this.isBusy = true;
      this.isDisabled = true;
      const { status, data } = await this.Api.get(
        `cobranza/unidades?perPage=${this.perPage}&page=${this.currentPage}`
      );
      if (status) {
        this.rows = data.total;
        this.cobranzaUnidades = data.data;
        this.cobranzaUnidades.sort(this.orderArrayOfObjects("economico"));
        this.cobranzaUnidades.forEach(unidad => {
          // Los datos de la columa Unidad se forman con el número económico y el nombre del socio
          let unidadCol = `${unidad.economico} - ${unidad.socioNombres}  ${unidad.socioApellidoPaterno}`;
          unidad = {
            unidad: unidadCol,
            cantidadRecibos: unidad.cantidadRecibos,
            debeTotal: unidad.montoTotalADeber
          };
          this.items.push(unidad);
        });
        if (this.items.length === 0) {
          this.isEmpty = true;
          this.isDisabled = true;
        } else {
          this.isDisabled = false;
        }
      }
      this.isBusy = false;
    },
    showText(entrada) {
      if (this.selected) {
        this.items = [];
        this.perPage = entrada;
        this.entrada = entrada;
        this.getCobranzaUnidades();
      }
      return (this.entrada = entrada.toString());
    },
    filterArrayOfObjects(items) {
      let distinctArray = Array.from(new Set(items.map(s => s.id))).map(id => {
        return {
          id: id,
          nombre: items.find(s => s.id === id).nombre
        };
      });
      return distinctArray;
    },
    orderArrayOfObjects(key, order = "asc") {
      return function innerSort(a, b) {
        if (
          !Object.prototype.hasOwnProperty.call(a, key) ||
          !Object.prototype.hasOwnProperty.call(b, key)
        ) {
          // property doesn't exist on either object
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    }
  }
};
